/* global google */
import React, { useState, useRef, useEffect } from "react";
// lucide-react icons removed — icons now served as SVG assets
import { Button, Modal } from "antd";
import { useLoadScript } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { loadScript } from "../../utils/loadScript";
import { toast } from "react-toastify";
import Thankyoupopup from "../Thankyoupopup/Thankyoupopup";
import BookingConfirmed, { CONFIRM_REDIRECT_MS } from "./BookingConfirmed";
import BookingConfirmedMob from "./BookingConfirmed_mob";
import CheckoutMob from "./Checkout_mob";
import CheckoutFaqs from "./CheckoutFaqs";
import { BookingTypeTag, getBookingTypeInfo, isEvVehicle } from "../Profileside/Profileside_shared";
import Termsandconditions from "../T&C/Termsandconditions";
import SubscriptionTermsandconditions from "../T&C/SubscriptionTermsandconditions";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

const getCatalogBookingTypes = () => {
  try {
    const cv = JSON.parse(localStorage.getItem("catalogValues") || "{}");
    const inv = cv?.bookingTypes?.inverted || {};
    return {
      dailyRentalId: Number(inv.dailyRental ?? 714),
      shortSubscriptionId: Number(inv.shortSubscription ?? 715),
      subscriptionId: Number(inv.subscription ?? 716),
    };
  } catch {
    return { dailyRentalId: 714, shortSubscriptionId: 715, subscriptionId: 716 };
  }
};

const formatRupee = (amount) =>
  `₹${(Number(amount) || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

const FareRow = ({ label, value, valueColor = "text-[#111827]" }) => (
  <div className="flex items-center justify-between gap-3 w-full text-[15px]">
    <span className="block text-[#374151] font-medium leading-6 text-left">{label}</span>
    <span className={`block ${valueColor} font-semibold leading-6 whitespace-nowrap`}>{value}</span>
  </div>
);

const ChargeRow = ({ label, amount }) => (
  <FareRow
    label={label}
    value={formatRupee(amount)}
    valueColor={Number(amount) > 0 ? "text-[#111827]" : "text-[#16a34a]"}
  />
);

const TermsCard = ({ onViewAll }) => (
  <div className="bg-white border border-[#f4efee] rounded-2xl p-6 flex flex-col gap-5 w-full">
    <div className="flex items-start justify-between w-full">
      <p className="text-[#1f2937] text-base font-semibold text-left">Terms and Conditions</p>
      <span onClick={onViewAll} className="text-[#2563eb] text-sm font-semibold underline cursor-pointer text-left">View All</span>
    </div>
    <div className="flex flex-col items-start gap-2 w-full">
      <p className="text-[#1f2937] text-sm font-bold text-left">Cancellation and Changes Policy:</p>
      <div className="text-[#6b7280] text-sm leading-relaxed space-y-2 text-left w-full">
        <p className="text-left">Customers can cancel the booking subject to the following conditions and charges. A cancellation refund will be done through the original payment method within 10 bank working days.</p>
        <p className="text-left">Customer should inform 24 hours prior the booking start time, in such instances, 70% of the amount will be refunded. If failed to inform 24 hours prior to the booking start time, no refund will be issued.</p>
        <p className="text-left"><span className="font-bold text-[#1f2937]">Please Note</span>: Any booking made within 24 hours of the start time will not be eligible for cancellation. Any cancellation request in such cases will result in a 100% penalty.</p>
      </div>
    </div>
  </div>
);

const Checkout = ({
  cityname,
  citydata,
  airportdata,
  hubid,
  cityid,
  cityId,
  setAirportDelivery,
  airportDelivery,
  pickup,
  setPickup,
  drop,
  setDrop,
  getdeliverychargesforpickup,
  carData,
  sethubname,
  hubname,
  setdeliverytype,
  deliverytype,
  setisself,
  setisclicked,
  dropcharges,
  setisdropclicked,
  dropcharges2,
  setDropOption,
  dropOption,
  getdeliverychargesfordrop,
  formattedEndDate,
  formattedStartDate,
  setcouponpostresponse,
  couponpostresponse,
  getcardetails,
  setdropcharges2,
  setdropcharges,
  setIsModalOpen,
  isModalOpen,
  seater,
  fuelType,
  tramissiontype,
  freekm,
  extraKm,
  plankm,
  duration,
  isSubscription,
  savedImageUrl,
  savedBodyType,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isCheckoutPage = location.pathname.startsWith("/bookings");
  const isMountedRef = useRef(false);

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const paymentApiKey = process.env.REACT_APP_RAZORPAY_KEY_ID;
  const token = localStorage.getItem("tokenWebsite");
  const packageSelectedKey = JSON.parse(localStorage.getItem("bookingvalues"))?.packageSelectedKey || "";
  const bookingTypeFromStorage = JSON.parse(localStorage.getItem("bookingvalues"))?.bookingType || null;
  // EV bookings get the EV card layout (badge + driving range) instead of fuel/body-type pills
  const isEvBooking = !!JSON.parse(localStorage.getItem("bookingvalues"))?.isEv
    || ["electric", "ev"].includes((fuelType || "").toLowerCase());
  const evDrivingRange = JSON.parse(localStorage.getItem("bookingvalues"))?.drivingRange || "";
  const evChargingType = JSON.parse(localStorage.getItem("bookingvalues"))?.chargingType || "";
  const { shortSubscriptionId, subscriptionId } = getCatalogBookingTypes();
  const GOOGLE_MAP_API_KEY = process.env.REACT_APP_MAP_API_KEY;
  const deliveryOptions = [
    { label: "Self Pickup", value: "hubPickup", defaultChecked: true },
    { label: "Home Delivery", value: "homeDelivery", defaultChecked: false },
  ];
  const [showMore, setShowMore] = useState(false);
  const [deliverytypeforapi, setdelvierytypeforapi] = useState("");

  const showModal = () => setIsModalOpen(true);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);
  const pickupRef = useRef(null);
  const dropRef = useRef(null);
  const paymentObjectRef = useRef(null);
  const redirectTimerRef = useRef(null); // auto-redirect after booking confirmation

  const [sameDrop, setSameDrop] = useState(true);
  const [manualCouponCode, setManualCouponCode] = useState("");
  const [manualCouponLoading, setManualCouponLoading] = useState(false);
  const [manualCouponApplied, setManualCouponApplied] = useState(false);
  const [couponopen, setcouponopen] = useState(false);
  const [coupondata, setcoupondata] = useState([]);
  const [couponapplied, setcouponapplied] = useState(false);
  const [generation, setGeneration] = useState(null);
  const [agreement, setAgreement] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCouponId, setSelectedCouponId] = useState(null);
  const [expandedCoupons, setExpandedCoupons] = useState({});
  const [copiedCouponId, setCopiedCouponId] = useState(null);
  const copiedCouponTimerRef = useRef(null);
  const [tandcOpen, setTandcOpen] = useState(false);
  const [confirmPayOpen, setConfirmPayOpen] = useState(false);
  const [isPickupFromGoogle, setIsPickupFromGoogle] = useState(false);
  const [isDropFromGoogle, setIsDropFromGoogle] = useState(false);
  const [pickupSuggestions, setPickupSuggestions] = useState([]);
  const [dropSuggestions, setDropSuggestions] = useState([]);
  const [pickupSuggestionsLoading, setPickupSuggestionsLoading] =
    useState(false);
  const [dropSuggestionsLoading, setDropSuggestionsLoading] = useState(false);
  const pickupRequestIdRef = useRef(0);
  const dropRequestIdRef = useRef(0);
  const [activeSuggestionType, setActiveSuggestionType] = useState(null);
  const [pickupFocused, setPickupFocused] = useState(false);
  const [dropFocused, setDropFocused] = useState(false);
  const autocompleteServiceRef = useRef(null);
  const placesServiceRef = useRef(null);
  const originalDropChargesRef = useRef(null);
  const [tabCloseBookingId, setTabCloseBookingId] = useState(null);
  const bookingIdRef = useRef(null);
  const [paymentDone, isPaymentDone] = useState(null);
  const [bookingCode, setBookingCode] = useState(null);
  const [isHomeDeliveryDisabled, setIsHomeDeliveryDisabled] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    loadScript("https://checkout.razorpay.com/v1/checkout.js").then(
      (loaded) => {
        if (!loaded) {
          alert("Razorpay SDK failed to load. Are you online?");
        }
      },
    );
  }, []);

  useEffect(() => {
    fetchCityConfig(cityId);
  }, [cityId]);

  const fetchCityConfig = async (cityId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookingconfigs?cityId=${cityId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setIsHomeDeliveryDisabled(data?.entities?.rows[0]);
      } else {
        setIsHomeDeliveryDisabled(null);
      }
    } catch (error) {
      console.error("Error fetching city config:", error);
    }
  };

  const forceCloseRazorpay = () => {
    try {
      // 1️⃣ Normal close
      if (
        paymentObjectRef.current &&
        typeof paymentObjectRef.current.close === "function"
      ) {
        paymentObjectRef.current.close();
      }
    } catch (e) {}

    // 2️⃣ HARD remove Razorpay DOM (iframe + overlay)
    const razorpayEls = document.querySelectorAll(
      'iframe[src*="razorpay"], .razorpay-container, .razorpay-overlay',
    );

    razorpayEls.forEach((el) => {
      try {
        el.remove();
      } catch (e) {}
    });

    // 3️⃣ Restore body scroll (Razorpay locks it)
    document.body.style.overflow = "auto";

    paymentObjectRef.current = null;
  };

  useEffect(() => {
    return () => {
      forceCloseRazorpay();
    };
  }, []);

  useEffect(() => {
    if (!isCheckoutPage) return;

    isMountedRef.current = true;

    if (paymentDone?.transactionCode) return;

    const INACTIVITY_TIMEOUT = 5 * 60 * 1000;
    let timer = null;
    let handled = false;

    const handleInactivity = async () => {
      if (!isMountedRef.current || handled) return;
      handled = true;

      console.warn("⏱️ Checkout inactivity triggered");

      forceCloseRazorpay();

      const bookingId = localStorage.getItem("bookingId");
      if (bookingId) {
        try {
          await fetch(`${apiUrl}/api/bookings/upatebookingstatus`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: token ? `${token}` : "",
            },
            body: JSON.stringify({ bookingId }),
          });
        } catch (e) {}
        localStorage.removeItem("bookingId");
      }

      navigate("/", { replace: true });
    };

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(handleInactivity, INACTIVITY_TIMEOUT);
    };

    const events = ["mousemove", "keydown", "scroll", "click", "touchstart"];
    events.forEach((e) => window.addEventListener(e, resetTimer));

    const handleVisibility = () => {
      if (!isMountedRef.current) return;

      if (document.hidden) {
        clearTimeout(timer);
        timer = setTimeout(handleInactivity, INACTIVITY_TIMEOUT);
      } else {
        resetTimer();
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);

    resetTimer();

    return () => {
      // 🔥 CRITICAL CLEANUP
      isMountedRef.current = false;
      clearTimeout(timer);

      events.forEach((e) => window.removeEventListener(e, resetTimer));
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [isCheckoutPage, paymentDone, navigate, apiUrl, token]);

  useEffect(() => {
    if (deliverytype === "Home Delivery") {
      setDropOption("select");
    } else {
      setDropOption("select");
    }
  }, [deliverytype]);

  console.log("deliverytype", deliverytype);

  const handleAirportChange = (e) => {
    const checked = e.target.checked;
    setAirportDelivery(checked);

    if (checked) {
      setIsPickupFromGoogle(true);
      setPickup(airportdata[0].airportAddress);
      if (pickupRef.current) {
        pickupRef.current.value = airportdata[0].airportAddress; // update the input manually
      }
    } else {
      setDrop("");
      setDropOption("select");
      setdropcharges2(null);
      setdropcharges(null);
      if (dropRef.current) {
        dropRef.current.value = ""; // reset the input
      }
      if (deliverytype === "Self Pickup") {
        setIsPickupFromGoogle(true);
        setPickup(hubname);
      } else {
        setPickup("");
        if (pickupRef.current) {
          pickupRef.current.value = ""; // reset the input
        }
      }
    }
  };

  // If user changes pickup or drop after applying a coupon, remove the coupon
  useEffect(() => {
    if (!selectedCouponId && !couponpostresponse) return;

    // Clear coupon state
    setSelectedCouponId(null);
    setcouponapplied(false);
    setcouponpostresponse(null);
    setManualCouponApplied(false);
    setManualCouponCode("");

    // Restore original drop charges if we had saved them
    if (originalDropChargesRef.current) {
      setdropcharges2({ ...originalDropChargesRef.current });
      originalDropChargesRef.current = null;
    }
  }, [pickup, drop]);

  const [manualSameDrop, setManualSameDrop] = useState(false);

  const handleDeliveryTypeChange = (type) => {
    setSelectedCouponId(null);
    setdeliverytype(type);
    setAirportDelivery(false);
    setSameDrop(true);
    setManualSameDrop(false); // <-- add this
    setDrop(""); // Clear drop on delivery type change
    setdropcharges2(null);
    setdropcharges(null);
    setcouponpostresponse(null);
    getcardetails();

    if (type === "Self Pickup") {
      setIsPickupFromGoogle(true); // Hub is a valid pickup location
      setPickup(hubname);
      setisself(true);
    } else {
      setPickup("");
      setisself(false);
      setIsPickupFromGoogle(false);
      setIsDropFromGoogle(false);
    }
  };

  useEffect(() => {
    if (pickup && !manualSameDrop && dropOption === "select") {
      setDrop("");
    }
  }, [pickup]);

  useEffect(() => {
    if (dropOption === "sameaspickup") {
      getdeliverychargesfordrop();
    }
  }, [dropOption, drop]);

  const libraries = ["places"];

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
    libraries: libraries,
  });

  const [bounds, setBounds] = useState(null);

  const cityNameSynonyms = {
    bangalore: ["bengaluru"],
    bengaluru: ["bangalore"],
    mysuru: ["mysore"],
    mysore: ["mysuru"],
    mysure: ["mysuru"],
  };

  const normalizeCityName = (name) =>
    name ? name.toString().trim().toLowerCase() : "";

  const cityNamesMatch = (cityA, cityB) => {
    if (!cityA || !cityB) return false;
    const normalizedA = normalizeCityName(cityA);
    const normalizedB = normalizeCityName(cityB);
    if (normalizedA === normalizedB) return true;
    return (
      cityNameSynonyms[normalizedA]?.includes(normalizedB) ||
      cityNameSynonyms[normalizedB]?.includes(normalizedA)
    );
  };

  const getMatchedCity = () => {
    if (!citydata || !cityname) return null;
    return (
      citydata.find((item) => cityNamesMatch(item.name, cityname)) ||
      citydata.find(
        (item) => normalizeCityName(item.name) === normalizeCityName(cityname),
      )
    );
  };

  // Fallback: try match by city id prop if name-based matching fails
  const getMatchedCityById = () => {
    const idToMatch = cityid || cityId || null;
    if (!idToMatch || !citydata) return null;
    return citydata.find((item) => Number(item.id) === Number(idToMatch));
  };

  const isPlaceWithinCity = (place, bounds, matchedCity) => {
    if (!place || !matchedCity) return false;

    if (bounds && place.geometry?.location && window.google?.maps) {
      try {
        if (bounds.contains(place.geometry.location)) {
          return true;
        }
      } catch (error) {
        // ignore invalid geometry
      }
    }

    const addressComponents = place.address_components || [];
    const componentNames = addressComponents
      .filter(
        (comp) =>
          comp.types?.includes("locality") ||
          comp.types?.includes("administrative_area_level_2") ||
          comp.types?.includes("administrative_area_level_1") ||
          comp.types?.includes("sublocality") ||
          comp.types?.includes("neighborhood"),
      )
      .flatMap((comp) => [
        normalizeCityName(comp.long_name),
        normalizeCityName(comp.short_name),
      ])
      .filter(Boolean);

    const targetCityName = normalizeCityName(matchedCity.name);
    return componentNames.some((name) => cityNamesMatch(name, targetCityName));
  };

  useEffect(() => {
    if (!citydata || !cityname || !window.google || !window.google.maps) return;

    const matchedCity = getMatchedCity() || getMatchedCityById();
    if (!matchedCity) {
      try {
        const names = (citydata || []).map((c) => c.name).slice(0, 50);
        console.warn(
          "Checkout: no matched city for",
          cityname,
          "available city names:",
          names,
        );
      } catch (e) {}
      return;
    }

    if (
      matchedCity.swLatLan &&
      matchedCity.neLatLan &&
      window.google &&
      window.google.maps &&
      window.google.maps.LatLng
    ) {
      const [swLat, swLng] = matchedCity.swLatLan
        .split(",")
        .map((val) => Number(val.trim()));
      const [neLat, neLng] = matchedCity.neLatLan
        .split(",")
        .map((val) => Number(val.trim()));

      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(new window.google.maps.LatLng(swLat, swLng));
      bounds.extend(new window.google.maps.LatLng(neLat, neLng));

      setBounds(bounds);
    }
  }, [citydata, cityname, isLoaded]);

  useEffect(() => {
    if (!isLoaded || !bounds || !window.google || !window.google.maps) return;

    if (!autocompleteServiceRef.current) {
      autocompleteServiceRef.current =
        new window.google.maps.places.AutocompleteService();
    }

    if (!placesServiceRef.current) {
      const dummyContainer = document.createElement("div");
      placesServiceRef.current = new window.google.maps.places.PlacesService(
        dummyContainer,
      );
    }
  }, [isLoaded, bounds]);

  const fetchCityPredictions = (
    input,
    setSuggestions,
    setLoading,
    requestIdRef,
  ) => {
    if (
      !isLoaded ||
      !autocompleteServiceRef.current ||
      !window.google?.maps?.places
    ) {
      setSuggestions([]);
      setLoading(false);
      return;
    }

    if (!input) {
      setSuggestions([]);
      setLoading(false);
      return;
    }

    const requestId = ++requestIdRef.current;
    setLoading(true);

    const matchedCity = getMatchedCity() || getMatchedCityById();

    // Debug info
    try {
      // eslint-disable-next-line no-console
      console.debug(
        "fetchCityPredictions: input=",
        input,
        "matchedCity=",
        matchedCity?.name || null,
        "boundsPresent=",
        !!bounds,
      );
    } catch (e) {}

    const filterAndSet = (predictions) => {
      if (requestId !== requestIdRef.current) return;

      if (!matchedCity) {
        setSuggestions(predictions || []);
        setLoading(false);
        return;
      }

      const normalizedCity = normalizeCityName(matchedCity.name || "");
      const citySynonyms = [
        normalizedCity,
        ...(cityNameSynonyms[normalizedCity] || []),
      ];

      const filtered = (predictions || []).filter((prediction) => {
        const description = normalizeCityName(prediction.description || "");
        return citySynonyms.some((city) => city && description.includes(city));
      });

      if (filtered.length > 0) setSuggestions(filtered);
      else setSuggestions(predictions || []);
      setLoading(false);
    };

    const handleResult = (predictions, status) => {
      if (requestId !== requestIdRef.current) return;
      if (
        status !== window.google.maps.places.PlacesServiceStatus.OK ||
        !predictions
      ) {
        setSuggestions([]);
        setLoading(false);
        return;
      }
      filterAndSet(predictions);
    };

    const baseReq = {
      input,
      componentRestrictions: { country: "in" },
      types: ["address"],
    };

    if (bounds) {
      autocompleteServiceRef.current.getPlacePredictions(
        { ...baseReq, bounds, strictBounds: true },
        handleResult,
      );
    } else {
      // No bounds available: request broader predictions and rely on filtering/validation on select
      autocompleteServiceRef.current.getPlacePredictions(baseReq, handleResult);
    }
  };

  const selectPrediction = (prediction, type) => {
    const setValue = type === "pickup" ? setPickup : setDrop;
    const setIsGoogle =
      type === "pickup" ? setIsPickupFromGoogle : setIsDropFromGoogle;
    const setSuggestions =
      type === "pickup" ? setPickupSuggestions : setDropSuggestions;
    const setFocused = type === "pickup" ? setPickupFocused : setDropFocused;

    if (!placesServiceRef.current || !window.google?.maps?.places) {
      toast.error("Location service is not available. Please try again.");
      return;
    }

    placesServiceRef.current.getDetails(
      {
        placeId: prediction.place_id,
        fields: ["formatted_address", "geometry", "address_components", "name"],
      },
      (place, status) => {
        if (
          status !== window.google.maps.places.PlacesServiceStatus.OK ||
          !place
        ) {
          toast.error("Unable to select this location. Please try another.");
          return;
        }

        const matchedCity = getMatchedCity() || getMatchedCityById();
        if (!matchedCity || !isPlaceWithinCity(place, bounds, matchedCity)) {
          toast.error(
            `Please select a location within ${matchedCity?.name || "the selected city"}.`,
          );
          setValue("");
          setIsGoogle(false);
          setSuggestions([]);
          return;
        }

        setValue(
          place.formatted_address || place.name || prediction.description,
        );
        setIsGoogle(true);
        setSuggestions([]);
        setActiveSuggestionType(null);
        setFocused(false);

        if (type === "pickup" && typeof setisclicked === "function") {
          setisclicked(true);
        }
        if (type === "drop" && typeof setisdropclicked === "function") {
          setisdropclicked(true);
        }
      },
    );
  };

  useEffect(() => {
    if (!carData) return;
    const getcoupons = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/api/coupons?cityId=${cityId}&groupId=${carData.vehicleGroupId}&isActive=true`,
        );
        const data = await response.json();
        if (
          data?.statusCode === "0100" &&
          data.entities &&
          data.entities.rows.length > 0
        ) {
          const sortedData = data.entities.rows.sort((a, b) => a.id - b.id);
          setcoupondata(sortedData);
        }
      } catch (error) {
        console.error("Error fetching get coupons:", error);
      }
    };

    getcoupons();
  }, [carData, cityId]);

  // keep bookingIdRef in sync with latest booking id (either explicit tabCloseBookingId or carData.id)
  useEffect(() => {
    bookingIdRef.current = tabCloseBookingId?.id ?? null;
  }, [tabCloseBookingId, carData]);

  const sendUpdateOnHide = () => {
    const id = bookingIdRef.current || localStorage.getItem("bookingId");
    if (!id) return;
    const url = `${apiUrl}/api/bookings/upatebookingstatus`;
    const body = JSON.stringify({ bookingId: id });

    try {
      // Use fetch with keepalive so the request has a chance to be sent during unload/pagehide.
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: token ? `${token}` : "",
        },
        body,
        keepalive: true,
      }).catch(() => {});
    } catch (err) {
      // best-effort; ignore errors during unload
    }
  };

  // Show confirmation when user attempts to close the tab/window, and
  // send a final request to update booking status when the page is actually being unloaded.
  useEffect(() => {
    const beforeUnload = (e) => {
      if (!bookingIdRef.current) return;
      // Standard message isn't shown in most browsers, but setting returnValue triggers confirmation
      e.preventDefault();
      e.returnValue =
        "Are you sure you want to leave? This will cancel the temporary booking.";
      return e.returnValue;
    };

    window.addEventListener("beforeunload", beforeUnload);
    window.addEventListener("pagehide", sendUpdateOnHide);

    return () => {
      window.removeEventListener("beforeunload", beforeUnload);
      window.removeEventListener("pagehide", sendUpdateOnHide);
    };
  }, [apiUrl, token]);

  if (!isLoaded) return <div>Loading...</div>;

  const handleCopyCoupon = async (coupon) => {
    try {
      await navigator.clipboard.writeText(coupon.couponCode);
    } catch {
      toast.error("Unable to copy coupon code", { position: "top-center" });
      return;
    }
    // toastId stops repeat clicks from stacking toasts
    toast.success("Coupon code copied", { position: "top-center", toastId: "coupon-copied" });
    setCopiedCouponId(coupon.id);
    clearTimeout(copiedCouponTimerRef.current);
    copiedCouponTimerRef.current = setTimeout(() => setCopiedCouponId(null), 3000);
  };

  const handlepostcouponapi = async (id) => {
    // Require both pickup and drop to be selected before applying a coupon.
    if (!pickup || !drop) {
      setcouponopen(false);
      toast.warn("To apply coupon select pickup and drop location", {
        position: "top-right",
        style: { zIndex: 2000 },
      });
      return;
    }

    if (!id || !pickup || !drop) return;

    // If same coupon clicked again -> remove it
    if (selectedCouponId === id) {
      setSelectedCouponId(null);
      setcouponapplied(false);
      setManualCouponApplied(false);
      setManualCouponCode("");
      setcouponpostresponse(null);

      if (originalDropChargesRef.current) {
        setdropcharges2({ ...originalDropChargesRef.current });
        originalDropChargesRef.current = null;
      } else {
        // fallback: attempt to restore using couponpostresponse if available
        setdropcharges2((prev) => ({
          ...prev,
          costToCustomer:
            couponpostresponse?.costToCustomer ?? prev?.costToCustomer,
        }));
      }

      return;
    }

    // Apply new coupon
    setSelectedCouponId(id);

    try {
      const response = await fetch(
        `${apiUrl}/api/bookings/applycoupondiscount-v2`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            costToCustomer: dropcharges2?.costToCustomer,
            couponId: id,
            weekdayRent: carData.weekdayRent,
            weekendRent: carData.weekendRent,
            securityDeposit: carData.securityDeposit,
            deliveryCharges: dropcharges2?.deliveryCharges,
            pickupCharges: dropcharges2?.pickupCharges,
            bookFrom: carData?.bookFrom,
            bookTo: carData?.bookTo,
            bookingId: carData?.id,
            cityId: cityId,
            ...((Number(carData?.bookingType) === subscriptionId || Number(carData?.bookingType) === shortSubscriptionId)
              ? { bookingType: carData.bookingType, isForSalesAgent: true }
              : { validForAllBookingTypes: 0 }),
          }),
        },
      ); 

      const data = await response.json();

      if (data?.statusCode === "0100") {
        // preserve original drop charges so we can restore later if address changes
        originalDropChargesRef.current = dropcharges2
          ? { ...dropcharges2 }
          : null;

        setcouponpostresponse(data?.dataValues);
        setcouponopen(false);
        setcouponapplied(true);

        // Update cost to customer with discounted value from API
        setdropcharges2((prev) => ({
          ...prev,
          costToCustomer: data?.dataValues?.discountedCostToCustomer,
          deliveryCharges:
            data?.dataValues?.deliveryCharges ?? prev?.deliveryCharges,
          pickupCharges: data?.dataValues?.pickupCharges ?? prev?.pickupCharges,
        }));

        return true;
      } else if (data?.result === -1) {
        toast.error(data?.msg);
        setcouponopen(false);
        setSelectedCouponId(null);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching coupon discount:", error);
    }

    return false;
  };

  const handleRemoveCoupon = () => {
    setSelectedCouponId(null);
    setcouponapplied(false);
    setManualCouponApplied(false);
    setManualCouponCode("");
    setcouponpostresponse(null);
    if (originalDropChargesRef.current) {
      setdropcharges2({ ...originalDropChargesRef.current });
      originalDropChargesRef.current = null;
    }
  };

  const handleManualCouponApply = async () => {
    if (!manualCouponCode.trim()) return;

    if (!pickup || !drop) {
      toast.warn("To apply coupon select pickup and drop location", {
        position: "top-right",
        style: { zIndex: 2000 },
      });
      return;
    }

    setManualCouponLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/coupons?couponCode=${encodeURIComponent(manualCouponCode.trim())}&cityId=${cityId}&groupId=${carData?.vehicleGroupId}&isActive=true&isAdminCall=true`,
        { headers: { "Content-Type": "application/json", Authorization: `${token}` } },
      );
      const data = await response.json();
      const couponRow = data?.entities?.rows?.[0];
      if (data?.statusCode === "0100" && couponRow?.id) {
        const success = await handlepostcouponapi(couponRow.id);
        if (success) setManualCouponApplied(true);
      } else {
        toast.error("Invalid or expired coupon code");
      }
    } catch (error) {
      toast.error("Failed to validate coupon code");
    } finally {
      setManualCouponLoading(false);
    }
  };

  const fetchBookingCode = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/vehiclebookings/${carData?.id}`, {
        headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: `${token}` },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") setBookingCode(data?.entityValue?.bookingCode);
    } catch (error) {
      console.error("Error fetching booking code:", error);
    }
  };

  const handleOrdergeneration = async () => {
    if (pickup && drop && agreement) {
      try {
        const response = await fetch(
          `${apiUrl}/api/razorpayorders/generateneworder`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `${token}`,
            },
            body: JSON.stringify({
              bookingDetails: {
                id: carData?.id,
                costToCustomer: couponpostresponse
                  ? couponpostresponse?.costToCustomerWithDiscount
                  : dropcharges2?.costToCustomer,
                deliveryCharges: couponpostresponse
                  ? couponpostresponse?.deliveryCharges
                  : dropcharges2?.deliveryCharges,
                pickupCharges: couponpostresponse
                  ? couponpostresponse?.pickupCharges
                  : dropcharges2?.pickupCharges,
                deliveryAddress: pickup,
                pickupAddress: drop,
                deliveryHubId: hubid,
                pickupHubId: hubid,
                taxAmount: couponpostresponse
                  ? couponpostresponse?.taxAmountWithDiscount
                  : carData?.taxAmount,
                discountAmount: couponpostresponse
                  ? couponpostresponse?.discountAmount
                  : 0,
                discountPercentage: couponpostresponse
                  ? couponpostresponse?.discountPercentage
                  : 0,
                deliveryType:
                  deliverytype === "Home Delivery"
                    ? "homeDelivery"
                    : "hubDelivery",
                pickupType: (() => {
                  // If user chose Self Pickup, pickupType depends on dropOption
                  if (deliverytype === "Self Pickup") {
                    return dropOption === "sameaspickup"
                      ? "hubPickup"
                      : "homePickup";
                  }

                  // If Home Delivery, pickup will always be from home
                  if (deliverytype == "Home Delivery") {
                    return "homePickup";
                  }

                  // Fallback: if same as pickup treat as hubPickup, otherwise homePickup
                  return dropOption == "sameaspickup"
                    ? "hubPickup"
                    : "homePickup";
                })(),
                packageSelectedKey: packageSelectedKey || undefined,
                bookingType: bookingTypeFromStorage || undefined,
                deliveryTypeInt: deliverytype == "Home Delivery" ? 1 : 0,
                pickupTypeInt: (() => {
                  // If user chose Self Pickup, pickupType depends on dropOption
                  if (deliverytype == "Self Pickup") {
                    return dropOption == "sameaspickup" ? 0 : 1;
                  }

                  // If Home Delivery, pickup will always be from home
                  if (deliverytype == "Home Delivery") {
                    return 1;
                  }

                  if (deliverytype == "Home Delivery") {
                    return dropOption == "sameaspickup" ? 1 : 1;
                  }

                  // Fallback: if same as pickup treat as hubPickup, otherwise homePickup
                  // return dropOption == "sameaspickup" ? 1 : 1;
                })(),
              },

              vehicleId: carData?.vehicleId,
              vehicleRegistartion: carData?.vehicleRegistrationNo,
              from: formattedStartDate,
              to: formattedEndDate,
              bookingId: carData?.id,
              amount: payableAmount,
              receipt: (carData?.id).toString(),
              notes: {},
              tempBookingObj: {
                id: carData?.tempBookingObj[0].id,
                tempBookingCode: carData?.tempBookingObj[0].tempBookingCode,
              },
              source: "website",
            }),
          },
        );
        const data = await response.json();

        if (data?.statusCode === "0100") {
          setLoading(true);
          localStorage.setItem("bookingId", carData?.id);
          bookingIdRef.current = carData?.id;   // set synchronously — don't wait for useEffect
          setTabCloseBookingId(carData);
          // setGeneration(data?.dataValues);
          const { amount, orderId, currency } = data?.dataValues;

          const options = {
            key: paymentApiKey,
            amount: amount.toString(),
            currency: currency,
            name: "Hcube Wowcarz",
            description: "Test Transaction",
            image: {},
            timeout: 300,
            order_id: orderId,
            handler: async function (response) {
              console.log("REPOSNE", response);
              if (response?.razorpay_payment_id) {
                isPaymentDone(data?.dataValues);
                setTimeout(async () => {
                  // a slow lookup must not hold up the confirmation; a late answer still fills the ID in
                  await Promise.race([fetchBookingCode(), new Promise((resolve) => setTimeout(resolve, 3000))]);
                  setOpen(true);
                  setLoading(false);
                  // keep the confirmation up for CONFIRM_REDIRECT_MS, then land on My Bookings (profile's default tab)
                  redirectTimerRef.current = setTimeout(() => {
                    setOpen(false);
                    navigate("/profile");
                  }, CONFIRM_REDIRECT_MS);
                }, 5000);
                paymentObjectRef.current = null;
                localStorage.removeItem("bookingvalues");
              }
              // const data = {
              //   paymentId: response?.razorpay_payment_id,
              //   amount: amount,
              //   bookingId: carData?.id,
              //   deliveryCharges: couponpostresponse
              //     ? couponpostresponse?.deliveryCharges
              //     : dropcharges2?.deliveryCharges,
              //   pickupCharges: couponpostresponse
              //     ? couponpostresponse?.pickupCharges
              //     : dropcharges2?.pickupCharges,
              //   deliveryAddress: pickup,
              //   pickupAddress: drop,
              //   deliveryHubId: hubid,
              //   pickupHubId: hubid,
              //   taxAmount: couponpostresponse
              //     ? couponpostresponse?.taxAmountWithDiscount
              //     : carData?.taxAmount,
              //   discountAmount: couponpostresponse
              //     ? couponpostresponse?.discountAmount
              //     : 0,
              //   discountPercentage: couponpostresponse
              //     ? couponpostresponse?.discountPercentage
              //     : 0,
              //   deliveryType:
              //     deliverytype === "Home Delivery"
              //       ? "homeDelivery"
              //       : "hubDelivery",
              //   pickupType: (() => {
              //     // If user chose Self Pickup, pickupType depends on dropOption
              //     if (deliverytype === "Self Pickup") {
              //       return dropOption === "sameaspickup"
              //         ? "hubPickup"
              //         : "homePickup";
              //     }

              //     // If Home Delivery, pickup will always be from home
              //     if (deliverytype == "Home Delivery") {
              //       return "homePickup";
              //     }

              //     // Fallback: if same as pickup treat as hubPickup, otherwise homePickup
              //     return dropOption == "sameaspickup"
              //       ? "hubPickup"
              //       : "homePickup";
              //   })(),
              //   deliveryTypeInt: deliverytype == "Home Delivery" ? 1 : 0,
              //   pickupTypeInt: (() => {
              //     // If user chose Self Pickup, pickupType depends on dropOption
              //     if (deliverytype == "Self Pickup") {
              //       return dropOption == "sameaspickup" ? 0 : 1;
              //     }

              //     // If Home Delivery, pickup will always be from home
              //     if (deliverytype == "Home Delivery") {
              //       return 1;
              //     }

              //     if (deliverytype == "Home Delivery") {
              //       return dropOption == "sameaspickup" ? 1 : 1;
              //     }

              //     // Fallback: if same as pickup treat as hubPickup, otherwise homePickup
              //     // return dropOption == "sameaspickup" ? 1 : 1;
              //   })(),
              //   // orderCreationId: orderId,
              //   // razorpayPaymentId: response.razorpay_payment_id,
              //   // razorpayOrderId: response.razorpay_order_id,
              //   // razorpaySignature: response.razorpay_signature,
              // };

              // return

              // try {
              //   setLoading(true);
              //   const headers = {
              //     "Content-Type": "application/json",
              //     Accept: "application/json",
              //     Authorization: `${token}`,
              //   };

              //   const result = await axios.post(
              //     `${apiUrl}/api/razorpayorders/payment/captureandbook`,
              //     data, // this is the request body
              //     { headers }, // this is the config object, which includes headers
              //   );
              //   if (result?.data?.statusCode === "0100") {
              //     isPaymentDone(data?.dataValues);
              //     setLoading(false); // Stop loading before showing popup
              //     setOpen(true); // Show Thank You popup
              //     paymentObjectRef.current = null;
              //     localStorage.removeItem("bookingvalues");
              //   } else if (result?.data?.result === -1) {
              //     setLoading(false);
              //     toast.error(result?.message);
              //   } else {
              //     toast.error(result?.message);
              //   }
              // } catch (error) {
              //   console.error("Error fetching payment capture api:", error);
              // }
            },
            modal: {
              ondismiss: async function () {
                setLoading(true);
                try {
                  const headers = {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `${token}`,
                  };

                  const data = {
                    bookingId: carData?.id,
                  };

                  const result = await axios.post(
                    `${apiUrl}/api/bookings/upatebookingstatus`,
                    data,
                    { headers },
                  );

                  console.log("Cancel booking API response:", result?.data);

                  if (result?.data?.statusCode === "0100") {
                    setLoading(false);
                    toast.success("Booking cancelled successfully");
                  } else {
                    toast.warning("Booking cancellation status unknown");
                  }
                } catch (error) {
                  console.error("Error cancelling booking:", error);
                  toast.error("Error cancelling booking");
                } finally {
                  // Always redirect to home after minimize, regardless of API response
                  setTimeout(() => {
                    navigate("/", { replace: true });
                  }, 500);
                }
              },
            },
            prefill: {
              name: carData?.customerName,
              email: carData?.customerEmail,
              contact: carData?.customerMobile,
            },
            notes: {
              address: "Hcube corporate office",
            },
            // theme : {
            //   color :
            // }
          };
          const paymentObject = new window.Razorpay(options);
          paymentObjectRef.current = paymentObject;
          paymentObject.on("payment.failed", function (response) {
            console.warn(
              "Payment Failed - BUT not cancelling booking",
              response.error.description,
            );
            paymentObjectRef.current = null;
            toast.error(
              "Payment failed. Please try again.",
              response.error.description,
            );
            setLoading(false);
          });

          paymentObject.open();
        } else {
          toast.error(data?.message);
          console.error("Unexpected API response:", data);
        }
      } catch (error) {
        console.error("Error fetching order generation:", error);
      }
    } else if (!pickup) {
      toast.error("Select pickup location");
    } else if (!drop) {
      toast.error("Select drop location");
    } else if (agreement === false) {
      toast.error("Please confirm the agreement policy");
    }
  };

  const tripDays = Math.floor((carData?.bookingHrs || 0) / 24);
  const tripHoursRem = (carData?.bookingHrs || 0) % 24;

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    return d.toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    });
  };

  const basePayable = Number(
    (couponpostresponse
      ? couponpostresponse?.costToCustomerWithDiscount
      : dropcharges2?.costToCustomer
        ? dropcharges2?.costToCustomer
        : carData?.costToCustomer
    )?.toFixed(2),
  ) || 0;

  const payableAmount = Number(basePayable.toFixed(2));

  const bookingConfirmedProps = {
    paymentDone,
    carData,
    savedImageUrl,
    savedBodyType,
    formattedStartDate,
    formattedEndDate,
    duration,
    cityname,
    pickup,
    drop,
    bookingCode,
    payableAmount,
    onViewBooking: () => { clearTimeout(redirectTimerRef.current); setOpen(false); navigate("/profile"); },
    onBackHome: () => { clearTimeout(redirectTimerRef.current); setOpen(false); navigate("/"); },
  };

  // Shared by the desktop and mobile views
  const tagBooking = { bookingType: carData?.bookingType || bookingTypeFromStorage };
  const bookingTypeTag = getBookingTypeInfo(tagBooking).isElectricCar && !isEvVehicle(carData?.vehicleDetails)
    ? null
    : <BookingTypeTag booking={tagBooking} inline />;

  const packageKmLabel = plankm ? `${plankm} KM` : freekm ? `${freekm} KM` : carData?.freekm ? `${carData.freekm} KM` : "—";
  const allottedKmLabel = freekm ? `${freekm} KM` : carData?.freekm ? `${carData.freekm} KM` : "—";
  const extraChargeLabel = extraKm ? `₹${extraKm}/KM` : carData?.extraKmCharge ? `₹${carData.extraKmCharge}/KM` : "—";

  const shortSubHomeDeliveryBlocked = isSubscription && carData?.shortSubscriptionHomeDelivery === false;
  const minHoursHomeDeliveryBlocked = carData?.bookingHrs < isHomeDeliveryDisabled?.homeDeliveryBookingHr &&
    isHomeDeliveryDisabled?.isHomeDeliveryDisabled === true;
  const isDeliveryOptionDisabled = (option) =>
    option?.value === "homeDelivery" && (shortSubHomeDeliveryBlocked || minHoursHomeDeliveryBlocked);

  const pickupInputProps = {
    ref: pickupRef,
    autoComplete: "off",
    type: "text",
    placeholder: "Enter a pickup location",
    value: pickup,
    onCopy: (e) => e.preventDefault(),
    onCut: (e) => e.preventDefault(),
    onPaste: (e) => e.preventDefault(),
    onFocus: () => {
      setPickupFocused(true);
      setActiveSuggestionType("pickup");
      if (!(deliverytype === "Self Pickup" || airportDelivery) && pickup?.trim()) {
        fetchCityPredictions(pickup, setPickupSuggestions, setPickupSuggestionsLoading, pickupRequestIdRef);
      }
    },
    onBlur: () => setTimeout(() => {
      setPickupSuggestions([]);
      setPickupSuggestionsLoading(false);
      setActiveSuggestionType(null);
      setPickupFocused(false);
    }, 150),
    onChange: (e) => {
      const value = e.target.value;
      if (!(deliverytype === "Self Pickup" || airportDelivery)) {
        setPickup(value);
        setIsPickupFromGoogle(false);
        if (value.trim()) {
          fetchCityPredictions(value, setPickupSuggestions, setPickupSuggestionsLoading, pickupRequestIdRef);
        } else {
          setPickupSuggestions([]);
          setPickupSuggestionsLoading(false);
        }
      } else {
        setIsPickupFromGoogle(true);
      }
    },
    disabled: deliverytype === "Self Pickup" || airportDelivery,
  };

  const dropInputProps = {
    ref: dropRef,
    autoComplete: "off",
    type: "text",
    placeholder: "Enter a drop location",
    value: drop,
    onFocus: () => {
      setDropFocused(true);
      setActiveSuggestionType("drop");
      if (!sameDrop && drop?.trim()) {
        fetchCityPredictions(drop, setDropSuggestions, setDropSuggestionsLoading, dropRequestIdRef);
      }
    },
    onBlur: () => setTimeout(() => {
      setDropSuggestions([]);
      setDropSuggestionsLoading(false);
      setActiveSuggestionType(null);
      setDropFocused(false);
    }, 150),
    onChange: (e) => {
      if (!sameDrop) {
        const value = e.target.value;
        setDrop(value);
        setIsDropFromGoogle(false);
        if (value.trim()) {
          fetchCityPredictions(value, setDropSuggestions, setDropSuggestionsLoading, dropRequestIdRef);
        } else {
          setDropSuggestions([]);
          setDropSuggestionsLoading(false);
        }
      }
    },
    disabled: dropOption === "select" || sameDrop,
  };

  const renderSuggestions = (type, suggestions, suggestionsLoading) => (
    <div className="absolute z-50 top-full left-0 right-0 mt-1 bg-white border rounded-md shadow-lg max-h-64 overflow-auto">
      {suggestionsLoading && suggestions.length === 0 ? (
        <div className="px-3 py-2 text-sm text-gray-500">Loading suggestions...</div>
      ) : (
        suggestions.map((prediction) => (
          <button type="button" key={prediction.place_id}
            className="w-full text-left px-3 py-2 hover:bg-gray-100 text-sm"
            onMouseDown={(event) => { event.preventDefault(); selectPrediction(prediction, type); }}>
            {prediction.description}
          </button>
        ))
      )}
    </div>
  );
  const pickupSuggestionList = pickupFocused && activeSuggestionType === "pickup" && (pickupSuggestions.length > 0 || pickupSuggestionsLoading)
    ? renderSuggestions("pickup", pickupSuggestions, pickupSuggestionsLoading) : null;
  const dropSuggestionList = dropFocused && activeSuggestionType === "drop" && (dropSuggestions.length > 0 || dropSuggestionsLoading)
    ? renderSuggestions("drop", dropSuggestions, dropSuggestionsLoading) : null;

  const handleDropOptionChange = (e) => {
    const value = e.target.value;
    const isSame = value === "sameaspickup";
    if (!pickup) { setDropOption("select"); return toast.error("Select Pickup location first"); }
    setDropOption(value);
    setSameDrop(isSame);
    setManualSameDrop(isSame);
    if (isSame) { setDrop(pickup); setIsDropFromGoogle(isPickupFromGoogle); }
    else { setDrop(""); setIsDropFromGoogle(false); }
  };

  const handleProceed = () => {
    if (!agreement) { toast.error("Please confirm the agreement policy"); return; }
    if (!pickup.trim()) { toast.error("Select pickup location"); return; }
    if (deliverytype !== "Self Pickup" && !isPickupFromGoogle) { toast.error("Please select pickup location from Google suggestions"); return; }
    if (!drop.trim()) { toast.error("Select drop location"); return; }
    if (!sameDrop && !isDropFromGoogle) { toast.error("Please select drop location from Google suggestions"); return; }
    setConfirmPayOpen(true);
  };

  return (
    <>
      {/* Loading overlay */}
      {loading && (
        <div className="fixed inset-0 flex justify-center items-center bg-white bg-opacity-85 z-50 h-screen">
          <div className="flex flex-col items-center gap-4">
            <div className="animate-spin rounded-full border-8 border-t-8 border-gray-200 border-t-blue-600 h-24 w-24"></div>
            <p className="text-lg font-semibold text-gray-700">Confirming your payment, Payment is processing</p>
            <p className="mt-2 text-black">Please don’t close or refresh the page</p>
            <p className="text-lg text-black">Hang tight! We’re confirming your booking.</p>
          </div>
        </div>
      )}

      {/* Confirm Pay Modal */}
      {confirmPayOpen && (
        <Modal open={confirmPayOpen} footer={null} closable={false} centered>
          <div className="text-center space-y-4">
            <h2 className="text-lg font-semibold">Confirm Payment</h2>
            <p className="text-gray-600">Do you want to proceed with the payment?</p>
            <div className="flex justify-center gap-4 mt-6">
              <Button onClick={() => setConfirmPayOpen(false)}>No</Button>
              <Button type="primary" danger onClick={() => { setConfirmPayOpen(false); handleOrdergeneration(); }}>Yes, Pay</Button>
            </div>
          </div>
        </Modal>
      )}

      {/* Booking Confirmed: full screen on mobile, modal on desktop */}
      {isMobile ? (
        open && <BookingConfirmedMob {...bookingConfirmedProps} />
      ) : (
        <Modal
          open={open}
          footer={null}
          closable={false}
          centered
          width="min(700px, 96vw)"
          styles={{ mask: { backgroundColor: "#ffffff" }, body: { padding: 0 }, content: { padding: 0, borderRadius: 32, overflow: "hidden", background: "transparent", boxShadow: "none" } }}
        >
          <BookingConfirmed {...bookingConfirmedProps} />
        </Modal>
      )}

      {/* Coupon Sidebar */}
      {couponopen && (
        <div className="fixed inset-0 z-[1100] font-['Outfit',sans-serif]">
          <div className="absolute inset-0 bg-black bg-opacity-40" onClick={() => setcouponopen(false)} />
          <div className="absolute right-0 top-0 w-full max-w-[420px] h-full bg-white border-l border-[#e5e7eb] shadow-[-8px_0px_12px_rgba(0,0,0,0.08)] flex flex-col">

            {/* Header */}
            <div className="flex items-center justify-between p-6 shrink-0 text-left items-start">
              <div className="flex flex-col gap-1">
                <span className="text-[#111827] text-[22px] font-bold leading-tight">Available Coupons</span>
                <span className="text-[#6b7280] text-[13px] font-normal">Choose a coupon to apply discounts to your booking</span>
              </div>
              <button
                onClick={() => setcouponopen(false)}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-[#e5e7eb] text-[#6b7280] hover:text-[#111827] shrink-0"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
              </button>
            </div>

            {/* Promo code input */}
            <div className="px-6 pb-4 shrink-0 text-left items-start">
              <p className="text-[#374151] text-[13px] font-semibold mb-2">Have a promo code?</p>
              <div className="border border-[#f2ebff] rounded-[10px] h-12 flex items-center justify-between pl-3.5 pr-1">
                <input
                  type="text"
                  placeholder="Enter coupon manually..."
                  value={manualCouponCode}
                  onChange={(e) => setManualCouponCode(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleManualCouponApply()}
                  className="flex-1 bg-transparent text-[#1f2937] text-[14px] outline-none placeholder:text-[#9ca3af]"
                />
                <button
                  type="button"
                  onClick={handleManualCouponApply}
                  disabled={manualCouponLoading}
                  className="flex items-center justify-center px-5 py-2.5 rounded-lg text-white text-[13px] font-bold shrink-0"
                  style={{ background: "linear-gradient(1.08deg, #a28fdc 0.74%, #7c3aed 74.61%)" }}
                >
                  {manualCouponLoading ? "..." : "Apply"}
                </button>
              </div>
            </div>

            {/* Coupon cards */}
            <div className="flex-1 overflow-y-auto px-6 py-2 flex flex-col gap-4 pb-8">
              {coupondata.length === 0 && (
                <p className="text-[#6b7280] text-sm text-center mt-8">No coupons available for this booking.</p>
              )}
              {coupondata.map((coupon) => {
                const isApplied = selectedCouponId === coupon.id;
                const discountLabel = coupon.discountType === "percentage" && coupon.discountValue
                  ? `${coupon.discountValue}% OFF`
                  : coupon.discountType === "flat" && coupon.discountValue
                  ? `₹${coupon.discountValue} OFF`
                  : null;
                // Strip HTML tags and decode entities for plain text description
                const rawDesc = coupon.description || coupon.termAndConditions || "";
                const tmp = document.createElement("div");
                tmp.innerHTML = rawDesc;
                const plainDesc = (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
                const isExpanded = !!expandedCoupons[coupon.id];
                const descTruncated = plainDesc.length > 80;
                const shortDesc = descTruncated && !isExpanded ? plainDesc.slice(0, 80) + "…" : plainDesc;
                const validTill = coupon.validTo
                  ? new Date(coupon.validTo).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
                  : null;
                return (
                  <div key={coupon.id} className={`bg-white rounded-[14px] border-[1.5px] border-dashed p-[18px] flex flex-col gap-4 shadow-[0px_2px_8px_0px_rgba(0,0,0,0.02)] w-full ${isApplied ? "border-[#7c3aed]" : "border-[rgba(0,168,107,0.3)]"}`}>
                    {/* Top row */}
                    <div className="flex flex-col gap-2.5 text-left items-start w-full">
                      <div className="flex items-start justify-between w-full">
                        <div className="bg-[#f0fdf4] border border-[#d1fae5] px-2.5 py-1 rounded-[6px] max-w-[70%] overflow-hidden">
                          <span className="text-[#065f46] text-[14px] font-bold tracking-[0.5px] truncate block">{coupon.couponCode}</span>
                        </div>
                        <button
                          type="button"
                          onClick={() => handleCopyCoupon(coupon)}
                          className="w-8 h-8 flex items-center justify-center rounded-full border border-[#ece6df] shrink-0"
                          title={copiedCouponId === coupon.id ? "Copied" : "Copy code"}
                        >
                          {copiedCouponId === coupon.id ? (
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7.5L5.5 11L12 3.5" stroke="#00a86b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
                          ) : (
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="4.5" y="4.5" width="8" height="8" rx="1.5" stroke="#6b7280" strokeWidth="1.2"/><path d="M2.5 9.5H2A1.5 1.5 0 0 1 .5 8V2A1.5 1.5 0 0 1 2 .5h6A1.5 1.5 0 0 1 9.5 2v.5" stroke="#6b7280" strokeWidth="1.2" strokeLinecap="round"/></svg>
                          )}
                        </button>
                      </div>
                      <div className="flex flex-col gap-1 w-full">
                        {discountLabel && (
                          <p className="text-[#111827] text-[20px] font-bold leading-tight">{discountLabel}</p>
                        )}
                        {shortDesc && (
                          <p className="text-[#4b5563] text-[13px] leading-[18px] break-words w-full">
                            {shortDesc}
                            {descTruncated && (
                              <button
                                type="button"
                                onClick={() => setExpandedCoupons(prev => ({ ...prev, [coupon.id]: !isExpanded }))}
                                className="ml-1 text-[#7c3aed] text-[12px] font-semibold underline"
                              >
                                {isExpanded ? "View less" : "View more"}
                              </button>
                            )}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Divider */}
                    <div className="border-t border-dashed border-[#e5e7eb]" />

                    {/* Bottom row */}
                    <div className="flex items-center justify-between">
                      {validTill && (
                        <div className="flex items-center gap-1.5">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6" stroke="#9ca3af" strokeWidth="1.2"/><path d="M7 4v3.5l2 1.5" stroke="#9ca3af" strokeWidth="1.2" strokeLinecap="round"/></svg>
                          <span className="text-[#6b7280] text-[12px]">Valid till {validTill}</span>
                        </div>
                      )}
                      <button
                        onClick={() => handlepostcouponapi(coupon.id)}
                        className={`px-[18px] py-2 rounded-[8px] text-white text-[13px] font-bold shadow-[0px_4px_5px_rgba(0,168,107,0.2)] ${isApplied ? "bg-[#6b7280]" : "bg-[#00a86b]"}`}
                      >
                        {isApplied ? "Remove" : "Apply"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Terms & Conditions Modal */}
      <Modal
        open={tandcOpen}
        onCancel={() => setTandcOpen(false)}
        footer={null}
        width="90vw"
        style={{ top: 20 }}
        styles={{ content: { paddingLeft: 4 }, body: { maxHeight: "80vh", overflowY: "auto", padding: "0 16px 16px 12px" } }}
      >
        <div className="flex flex-col items-start text-left [&>div]:w-full [&>div]:pt-0 [&>div]:min-h-0 [&>div>div]:pl-0 [&_.text-center]:text-left">
          {isSubscription ? <SubscriptionTermsandconditions /> : <Termsandconditions />}
        </div>
      </Modal>

      {/* Fare Details Modal */}
      {isModalOpen && (
        <Modal
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          closable={false}
          footer={null}
          centered
          width={480}
          styles={{
            body: { padding: 0 },
            content: {
              padding: 0,
              borderRadius: 20,
              overflow: "hidden",
              border: "1px solid #e5e7eb",
              boxShadow: "0px 16px 32px 0px rgba(0,0,0,0.12)",
            },
          }}
        >
          <div className="flex flex-col w-full font-['Outfit',sans-serif] text-left">
            <div className="flex items-center justify-between gap-3 border-b border-[#e5e7eb] px-6 pt-6 pb-4">
              <div className="flex flex-col gap-1 items-start min-w-0">
                <span className="block text-[#111827] text-[20px] font-extrabold leading-7">Payment Summary</span>
                {carData?.vehicleName && (
                  <span className="block text-[#6b7280] text-[13px] font-medium leading-5">{carData.vehicleName}</span>
                )}
              </div>
              <button
                type="button"
                onClick={handleCancel}
                aria-label="Close"
                className="bg-[#f3f4f6] rounded-2xl size-8 flex items-center justify-center shrink-0 cursor-pointer"
              >
                <img src="/assets/checkout/fare-close.svg" alt="" className="shrink-0" />
              </button>
            </div>

            <div className="flex flex-col gap-4 p-6 w-full">
              <FareRow label="Base Fare" value={formatRupee(carData?.weekdayRent + carData?.weekendRent)} />
              {couponpostresponse?.discountAmount > 0 && (
                <FareRow
                  label="Discount Amount"
                  value={`-${formatRupee(couponpostresponse.discountAmount)}`}
                  valueColor="text-[#dc2626]"
                />
              )}
              <FareRow label="Tax Fee" value={formatRupee(couponpostresponse?.taxAmountWithDiscount || carData?.taxAmount)} />
              <ChargeRow label="Pickup Charges" amount={couponpostresponse ? couponpostresponse?.deliveryCharges : dropcharges2?.deliveryCharges} />
              <ChargeRow label="Drop Off Charges" amount={couponpostresponse ? couponpostresponse?.pickupCharges : dropcharges2?.pickupCharges} />
              <FareRow label="Security Deposit" value={formatRupee(couponpostresponse?.securityDeposit || carData?.securityDeposit)} />
              <img src="/assets/checkout/fare-dashed-divider.png" alt="" className="block w-full h-px object-cover object-left" />
              <div className="flex items-center justify-between gap-3 pt-1 w-full text-[clamp(20px,6.2vw,24px)]">
                <span className="block text-[#111827] font-bold leading-8 text-left">Total Payable</span>
                <span className="block text-[#cd2525] font-extrabold leading-8 whitespace-nowrap">{formatRupee(payableAmount)}</span>
              </div>
            </div>

            {couponpostresponse?.discountAmount > 0 && (
              <div className="bg-[#e5f4e5] flex items-center justify-center px-4 py-3.5 w-full">
                <span className="block text-[#15803d] text-[13px] font-semibold leading-5 tracking-[0.13px] text-center">
                  🤩 Yay! {formatRupee(couponpostresponse.discountAmount)} saved! Your coupon has been applied successfully.
                </span>
              </div>
            )}
          </div>
        </Modal>
      )}

      {isMobile ? (
        <CheckoutMob
          carData={carData}
          savedImageUrl={savedImageUrl}
          bookingTypeTag={bookingTypeTag}
          isEvBooking={isEvBooking}
          evDrivingRange={evDrivingRange}
          evChargingType={evChargingType}
          features={{
            seats: seater || carData?.seats || null,
            transmission: tramissiontype || carData?.transmission || null,
            fuel: fuelType || carData?.fuelType || null,
            bodyType: savedBodyType || carData?.vehicleCategory || carData?.vehicleType || null,
          }}
          cityname={cityname}
          isSubscription={isSubscription}
          packageKmLabel={packageKmLabel}
          allottedKmLabel={allottedKmLabel}
          extraChargeLabel={extraChargeLabel}
          payableAmount={payableAmount}
          formattedStartDate={formattedStartDate}
          formattedEndDate={formattedEndDate}
          tripDuration={(carData?.bookingHrs > 0 || duration) ? (duration || `${tripDays} Days ${tripHoursRem} Hours 0 Minutes`) : null}
          deliveryOptions={deliveryOptions}
          deliverytype={deliverytype}
          isDeliveryOptionDisabled={isDeliveryOptionDisabled}
          handleDeliveryTypeChange={handleDeliveryTypeChange}
          shortSubHomeDeliveryBlocked={shortSubHomeDeliveryBlocked}
          minHoursHomeDeliveryBlocked={minHoursHomeDeliveryBlocked}
          homeDeliveryBookingHr={isHomeDeliveryDisabled?.homeDeliveryBookingHr}
          pickupInputProps={pickupInputProps}
          pickupSuggestionList={pickupSuggestionList}
          dropInputProps={dropInputProps}
          dropSuggestionList={dropSuggestionList}
          dropOption={dropOption}
          handleDropOptionChange={handleDropOptionChange}
          airportDelivery={airportDelivery}
          handleAirportChange={handleAirportChange}
          couponpostresponse={couponpostresponse}
          coupondata={coupondata}
          setcouponopen={setcouponopen}
          handleRemoveCoupon={handleRemoveCoupon}
          manualCouponCode={manualCouponCode}
          setManualCouponCode={setManualCouponCode}
          manualCouponLoading={manualCouponLoading}
          handleManualCouponApply={handleManualCouponApply}
          agreement={agreement}
          setAgreement={setAgreement}
          setTandcOpen={setTandcOpen}
          showModal={showModal}
          handleProceed={handleProceed}
        />
      ) : (
      <>
      {/* ── Two-column layout ── */}
      <div className="flex flex-col lg:flex-row gap-8 items-start w-full font-[‘Outfit’,sans-serif] pb-10 bg-[#FFFAF9]">

        {/* ── LEFT COLUMN ── */}
        <div className="flex flex-col gap-8 w-full lg:w-1/2 min-w-0">

          {/* Hero Car Card */}
          <div className="bg-white border border-[#f4efee] rounded-2xl">
            <div className="flex items-start gap-5 px-4 py-[18px]">
              {/* Car image */}
              <div className="flex flex-col justify-center h-[168px] w-[247px] shrink-0">
                <img
                  src={carData?.vehicleDetails?.imageUrl || carData?.vehicleDetails?.vehicleImgThumb || carData?.imageUrl || savedImageUrl || "/assets/logo.png"}
                  alt={carData?.vehicleName || "Car"}
                  className="w-full max-h-[155px] object-contain scale-[1.18] origin-center"
                  loading="lazy"
                />
              </div>
              {/* Meta */}
              <div className="flex flex-col gap-4 flex-1 min-w-0 items-start">
                <div className="flex items-start justify-between gap-2 w-full">
                  <div className="flex flex-col gap-2 items-start flex-1 min-w-0">
                    <div className="flex flex-wrap items-center justify-between gap-2 w-full">
                      <p className="text-[#1f2937] text-2xl font-bold text-left min-w-0">{carData?.vehicleName || "Your Vehicle"}</p>
                      {bookingTypeTag}
                    </div>
                  </div>
                </div>
                {isEvBooking ? (
                  <div className="flex flex-col gap-2 w-full">
                    <div className="flex gap-2 w-full">
                      {[
                        (seater || carData?.seats) ? `${seater || carData.seats} Seater` : null,
                        tramissiontype || carData?.transmission || null,
                        savedBodyType || carData?.vehicleCategory || carData?.vehicleType || null,
                      ].filter(Boolean).map((feature) => (
                        <div key={feature} className="bg-[#f3f4f6] flex-1 min-w-0 px-[10px] py-1 rounded-md text-left">
                          <span className="text-[#6b7280] text-xs font-semibold font-['Outfit']">{feature}</span>
                        </div>
                      ))}
                    </div>
                    {evChargingType && (
                      <div className="bg-[#f3f4f6] w-full px-[10px] py-1 rounded-md text-left">
                        <span className="text-[#6b7280] text-xs font-semibold font-['Outfit']">{evChargingType} Charging</span>
                      </div>
                    )}
                    {evDrivingRange && (
                      <div className="bg-[#f3f4f6] w-full px-[10px] py-1 rounded-md text-left">
                        <span className="text-[#6b7280] text-xs font-semibold font-['Outfit']">Driving Range : {evDrivingRange} Km</span>
                      </div>
                    )}
                  </div>
                ) : (
                <div className="flex flex-col gap-2 w-full">
                  <div className="flex flex-wrap gap-2 w-full">
                    {[
                      seater ? `${seater} Seats` : (carData?.seats ? `${carData.seats} Seats` : null),
                      savedBodyType || carData?.vehicleCategory || carData?.vehicleType || null,
                    ].filter(Boolean).map((feature) => (
                      <div key={feature} className="bg-[#ecfdf5] flex-1 flex items-center gap-1.5 px-3 py-1.5 rounded-lg">
                        <img src="/assets/checkout/check-circle.svg" alt="" className="w-3 h-3 shrink-0" />
                        <span className="text-[#5c5c5c] text-sm font-medium text-left whitespace-nowrap">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div className="flex flex-wrap gap-2 w-full">
                    {[
                      fuelType ? `Fuel: ${fuelType}` : (carData?.fuelType ? `Fuel: ${carData.fuelType}` : null),
                      tramissiontype || (carData?.transmission ? carData.transmission : null),
                    ].filter(Boolean).map((feature) => (
                      <div key={feature} className="bg-[#ecfdf5] flex-1 flex items-center gap-1.5 px-3 py-1.5 rounded-lg">
                        <img src="/assets/checkout/check-circle.svg" alt="" className="w-3 h-3 shrink-0" />
                        <span className="text-[#5c5c5c] text-sm font-medium text-left whitespace-nowrap">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
                )}
              </div>
            </div>
            <hr className="border-[#f4efee]" />
            <p className="text-[#9ca3af] text-[11px] leading-4 px-4 py-[14px] text-left">
              Disclaimer: The car image shown is for representation purposes only. Actual color, appearance, and specific features of the vehicle may vary depending on local fleet availability at the pickup time.
            </p>
          </div>

          {/* Pricing & Plan + Booking Summary */}
          <div className="flex flex-col gap-3 font-['Outfit',sans-serif]">
            {/* Plan grid + Amount to Pay */}
            <div className="flex gap-3 items-stretch -mb-2">
              <div className="flex flex-col gap-4 flex-1 min-w-0">
                <div className="flex gap-4 items-start">
                  <div className="flex flex-col gap-1 flex-1 items-start">
                    <span className="block text-[#959595] text-[13px] font-medium leading-5 text-left">City</span>
                    <span className="block text-[#1f2937] text-[16px] font-semibold uppercase tracking-[0.48px] leading-6 text-left">{cityname || "—"}</span>
                  </div>
                  {!isSubscription && (
                    <div className="flex flex-col gap-1 flex-1 items-start">
                      <span className="block text-[#959595] text-[13px] font-medium leading-5 text-left">Selected package</span>
                      <span className="block text-[#1f2937] text-[16px] font-semibold uppercase tracking-[0.48px] leading-6 text-left">{packageKmLabel}</span>
                    </div>
                  )}
                </div>
                <div className="flex gap-4 items-start">
                  <div className="flex flex-col gap-1 flex-1 items-start">
                    <span className="block text-[#959595] text-[13px] font-medium leading-5 text-left">Allotted KM</span>
                    <span className="block text-[#10b981] text-[16px] font-semibold uppercase tracking-[0.48px] leading-6 text-left">{allottedKmLabel}</span>
                  </div>
                  <div className="flex flex-col gap-1 flex-1 items-start">
                    <span className="block text-[#959595] text-[13px] font-medium leading-5 text-left">Extra Charges</span>
                    <span className="block text-[#1f2937] text-[16px] font-semibold uppercase tracking-[0.48px] leading-6 text-left">{extraChargeLabel}</span>
                  </div>
                </div>
              </div>
              <div className="bg-[#f6f1ff] rounded-[10px] p-4 flex flex-col gap-3 items-start justify-center w-[174px] shrink-0">
                <span className="block text-[#808080] text-[14px] font-bold leading-5">Amount to Pay</span>
                <span className="block text-[#cd2525] text-[32px] font-extrabold leading-10 whitespace-nowrap">₹{payableAmount} /-</span>
              </div>
            </div>

            <hr className="border-[#e5e7eb]" />

            {/* Booking Summary & Schedule Card */}
            <div className="bg-white border border-[#f4efee] rounded-2xl px-4 py-[18px] flex flex-col gap-3">
              <span className="block text-[#1f2937] text-xl font-semibold leading-7 text-left">Booking Summary &amp; Schedule</span>
              <div className="flex items-center gap-6 w-full">
                <div className="flex-1 bg-[#f9fafb] border border-[#e5e7eb] rounded-[10px] px-4 py-3 flex flex-col gap-1.5 items-start">
                  <span className="block text-[#6b7280] text-[12px] font-semibold uppercase leading-4 text-left">Start Date &amp; Time</span>
                  <span className="block text-[#1f2937] text-[16px] font-bold leading-6 text-left">{formatDisplayDate(formattedStartDate)}</span>
                </div>
                <div className="bg-[#f3f4f6] rounded-full w-10 h-10 flex items-center justify-center shrink-0">
                  <img src="/assets/checkout/arrow-right.svg" alt="" className="w-[18px] h-[18px]" />
                </div>
                <div className="flex-1 bg-[#f9fafb] border border-[#e5e7eb] rounded-[10px] px-4 py-3 flex flex-col gap-1.5 items-start">
                  <span className="block text-[#6b7280] text-[12px] font-semibold uppercase leading-4 text-left">End Date &amp; Time</span>
                  <span className="block text-[#1f2937] text-[16px] font-bold leading-6 text-left">{formatDisplayDate(formattedEndDate)}</span>
                </div>
              </div>
              {(carData?.bookingHrs > 0 || duration) && (
                <div className="bg-[rgba(182,139,255,0.12)] rounded-[10px] px-3 py-2 flex items-center gap-3 w-full">
                  <img src="/assets/checkout/clock.svg" alt="" className="w-5 h-5 shrink-0" />
                  <span className="block text-[#7c3aed] text-[14px] font-semibold leading-5 flex-1 min-w-0 text-left">
                    Total Trip Duration: <span className="font-bold">{duration || `${tripDays} Days ${tripHoursRem} Hours 0 Minutes`}</span>
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* EV: FAQs take this slot and Terms & Conditions moves below the columns */}
          {isEvBooking ? <CheckoutFaqs /> : <TermsCard onViewAll={() => setTandcOpen(true)} />}
        </div>

        {/* ── RIGHT COLUMN ── */}
        <div className="flex flex-col gap-6 w-full lg:w-1/2 shrink-0">

          {/* Pickup & Delivery Mode Card */}
          <div className="bg-white border border-[#f4efee] rounded-2xl p-6 flex flex-col gap-4">
            <p className="text-[#1f2937] text-xl font-semibold text-left">Pickup &amp; Delivery</p>

            {/* Delivery type toggle buttons */}
            <div className="flex gap-3">
              {deliveryOptions.map((option) => {
                const isDisabled = isDeliveryOptionDisabled(option);
                const isActive = deliverytype === option.label;
                return (
                  <button
                    key={option.value}
                    type="button"
                    disabled={isDisabled}
                    onClick={() => handleDeliveryTypeChange(option.label)}
                    className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-xl border text-sm transition-all
                      ${isActive ? "bg-[rgba(124,58,237,0.06)] border-[#a28fdc] border-[1.5px] text-[#0c2d75] font-bold" :
                        isDisabled ? "bg-white border-[#e5e7eb] text-gray-400 cursor-not-allowed opacity-60" :
                        "bg-white border-[#e5e7eb] text-[#6b7280] font-medium"}`}
                  >
                    <img
                      src={isActive ? "/assets/checkout/ellipse-active.svg" : "/assets/checkout/ellipse-inactive.svg"}
                      alt="" className="w-3 h-3"
                    />
                    {option.label}
                  </button>
                );
              })}
            </div>

            {/* Home delivery notices */}
            {shortSubHomeDeliveryBlocked && (
              <small className="text-xs text-red-500">
                Note: Home delivery is not available for short subscriptions (7 days)
              </small>
            )}
            {!shortSubHomeDeliveryBlocked && minHoursHomeDeliveryBlocked && (
              <small className="text-xs text-red-500">
                Note: Home delivery requires a minimum booking duration of {isHomeDeliveryDisabled?.homeDeliveryBookingHr} hours
              </small>
            )}

            {/* Pickup location */}
            <div className="flex flex-col gap-1.5 w-full">
              <span className="text-[#6b7280] text-[14px] font-semibold uppercase text-left font-['Outfit'] leading-none pl-3.5 pb-2">Pick Up Hub Location</span>
              <div className="relative bg-[#fafafa] border border-[#e5e7eb] rounded-xl px-3.5 py-3 flex items-center gap-2.5">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M16.6679 8.3333C16.6679 12.4945 12.0526 16.8282 10.5027 18.1667C10.3583 18.2753 10.1826 18.334 10.0019 18.334C9.82129 18.334 9.64554 18.2753 9.50115 18.1667C7.95131 16.8282 3.33594 12.4945 3.33594 8.3333C3.33594 6.56502 4.03825 4.86918 5.28836 3.61882C6.53848 2.36846 8.234 1.66602 10.0019 1.66602C11.7699 1.66602 13.4654 2.36846 14.7155 3.61882C15.9656 4.86918 16.6679 6.56502 16.6679 8.3333ZM12.5017 8.3333C12.5017 9.71414 11.3825 10.8335 10.0019 10.8335C8.62136 10.8335 7.50219 9.71414 7.50219 8.3333C7.50219 6.95246 8.62136 5.83307 10.0019 5.83307C11.3825 5.83307 12.5017 6.95246 12.5017 8.3333Z" stroke-width="2" stroke-linecap="round" stroke="#6B7280"/>
</svg>
                <input
                  {...pickupInputProps}
                  className="flex-1 bg-transparent text-[#1f2937] text-[14px] font-medium font-['Outfit'] leading-normal outline-none overflow-hidden text-ellipsis placeholder:text-[#9ca3af]"
                />
                {pickupSuggestionList}
              </div>
            </div>

            {/* Airport delivery checkbox */}
            {deliverytype === "Home Delivery" && cityname !== "Vellore" && (
              <div className="flex items-center gap-2">
                <input type="checkbox" id="airportDelivery" checked={airportDelivery} onChange={handleAirportChange} className="h-4 w-4" />
                <label htmlFor="airportDelivery" className="text-sm font-medium text-gray-700">is Airport Delivery</label>
              </div>
            )}

            {/* Drop location */}
            <div className="flex flex-col gap-1.5 w-full">
              <span className="text-[#1f2937] text-[14px] font-semibold text-left font-['Outfit']">Drop location</span>
              <select
                className="border border-[#e5e7eb] rounded-xl px-3.5 py-2.5 text-sm text-[#374151] bg-white self-start min-w-[110px]"
                value={dropOption}
                onChange={handleDropOptionChange}
              >
                <option value="select">select</option>
                <option value="sameaspickup">Same as Pickup</option>
                {!minHoursHomeDeliveryBlocked && (
                  <option value="differentlocation">Different Location</option>
                )}
              </select>

              <div className="relative bg-[#fafafa] border border-[#e5e7eb] rounded-xl px-3.5 py-3 flex items-center gap-2.5">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M16.6679 8.3333C16.6679 12.4945 12.0526 16.8282 10.5027 18.1667C10.3583 18.2753 10.1826 18.334 10.0019 18.334C9.82129 18.334 9.64554 18.2753 9.50115 18.1667C7.95131 16.8282 3.33594 12.4945 3.33594 8.3333C3.33594 6.56502 4.03825 4.86918 5.28836 3.61882C6.53848 2.36846 8.234 1.66602 10.0019 1.66602C11.7699 1.66602 13.4654 2.36846 14.7155 3.61882C15.9656 4.86918 16.6679 6.56502 16.6679 8.3333ZM12.5017 8.3333C12.5017 9.71414 11.3825 10.8335 10.0019 10.8335C8.62136 10.8335 7.50219 9.71414 7.50219 8.3333C7.50219 6.95246 8.62136 5.83307 10.0019 5.83307C11.3825 5.83307 12.5017 6.95246 12.5017 8.3333Z" stroke-width="2" stroke-linecap="round" stroke="#6B7280"/>
</svg>
                <input
                  {...dropInputProps}
                  className="flex-1 bg-transparent text-[#1f2937] text-[14px] font-medium font-['Outfit'] leading-normal outline-none overflow-hidden text-ellipsis placeholder:text-[#9ca3af]"
                />
                {dropSuggestionList}
              </div>
            </div>

            <p className="text-[#6b7280] text-[11px] text-left w-full">* Delivery charges applicable as extra according to hub to delivery address distance.</p>
            <small className="text-xs text-left text-gray-500 w-full">Disclaimer: Delivery Charges may vary for above 20+ km / outside city limits locations. The same will be confirmed upon KYC verification.</small>
          </div>

          {/* Coupons Card */}
          <div className="bg-white border border-[#f4efee] rounded-2xl p-2 w-full">
            <AnimatePresence mode="wait">
              {couponpostresponse ? (
                <motion.div
                  key="applied"
                  initial={{ opacity: 0, y: -8 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -8 }}
                  transition={{ duration: 0.25 }}
                  className="flex items-center gap-3 p-3 rounded-xl w-full"
                >
                  {/* Green ticket icon */}
                  <div className="bg-[#e4fff5] rounded-xl w-8 h-8 flex items-center justify-center shrink-0">
                    <img src="/assets/checkout/ticket.svg" alt="" className="w-4 h-4" style={{ filter: "invert(46%) sepia(74%) saturate(462%) hue-rotate(112deg) brightness(96%) contrast(101%)" }} />
                  </div>

                  {/* Coupon info */}
                  <div className="flex flex-col gap-0.5 items-start flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-[#00a86b] text-sm font-bold tracking-wide">{couponpostresponse?.couponCode}</span>
                      <span className="bg-[#e4fff5] border border-[#a7f3d0] text-[#065f46] text-[10px] font-bold px-2 py-0.5 rounded-full">Applied ✓</span>
                    </div>
                    {couponpostresponse?.discountAmount > 0 && (
                      <p className="text-[#6b7280] text-[11px]">
                        You save <span className="text-[#00a86b] font-semibold">₹{couponpostresponse.discountAmount}</span> with this coupon
                      </p>
                    )}
                  </div>

                  {/* Edit / Remove */}
                  <div className="flex items-center gap-1 shrink-0">
                    <button
                      type="button"
                      onClick={() => setcouponopen(true)}
                      className="px-3 py-1.5 rounded-lg border border-[#e5e7eb] text-[#374151] text-[12px] font-semibold hover:bg-gray-50 transition-colors"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      onClick={handleRemoveCoupon}
                      className="px-3 py-1.5 rounded-lg border border-[#fee2e2] text-[#dc2626] text-[12px] font-semibold hover:bg-red-50 transition-colors"
                    >
                      Remove
                    </button>
                  </div>
                </motion.div>
              ) : (
                <motion.div
                  key="not-applied"
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 8 }}
                  transition={{ duration: 0.25 }}
                  className="flex flex-col gap-3"
                >
                  {/* Open sidebar button */}
                  <button
                    disabled={coupondata.length < 1}
                    type="button"
                    onClick={() => setcouponopen(true)}
                    className="flex items-center gap-3 p-3 rounded-xl w-full hover:bg-gray-50 transition-colors disabled:cursor-not-allowed disabled:opacity-60"
                  >
                    <div className="bg-[#f8f8fa] rounded-xl w-8 h-8 flex items-center justify-center shrink-0">
                      <img src="/assets/checkout/ticket.svg" alt="" className="w-4 h-4" />
                    </div>
                    <div className="flex flex-1 items-center justify-between">
                      <div className="flex flex-col gap-0.5 items-start">
                        <p className="text-[#1a1a1a] text-sm font-semibold text-left">Coupons</p>
                        <p className="text-[#a3a3a3] text-[10px] font-semibold text-left">View all coupons</p>
                      </div>
                      {coupondata.length > 0 ? (
                        <div className="bg-[#e4fff5] px-3 py-1 rounded-md">
                          <p className="text-[#00a86b] text-xs font-semibold">{coupondata.length} Available</p>
                        </div>
                      ) : (
                        <p className="text-[#6b7280] text-xs">No coupons available</p>
                      )}
                    </div>
                  </button>

                  {/* Promo code input */}
                  <div className="flex flex-col gap-2 px-1 pb-1">
                    <p className="text-[#374151] text-[13px] font-semibold text-left">Have a promo code?</p>
                    <div className="border border-[#f2ebff] rounded-[10px] h-12 flex items-center justify-between pl-3.5 pr-1">
                      <input
                        type="text"
                        placeholder="Enter coupon manually..."
                        value={manualCouponCode}
                        onChange={(e) => setManualCouponCode(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleManualCouponApply()}
                        className="flex-1 bg-transparent text-[#1f2937] text-[14px] font-normal font-['Outfit'] outline-none placeholder:text-[#9ca3af] w-[220px]"
                      />
                      <button
                        type="button"
                        onClick={handleManualCouponApply}
                        disabled={manualCouponLoading}
                        className="flex items-center justify-center px-5 py-2.5 rounded-lg text-white text-[13px] font-bold shrink-0"
                        style={{ background: "linear-gradient(1.08deg, #a28fdc 0.74%, #7c3aed 74.61%)" }}
                      >
                        {manualCouponLoading ? "..." : "Apply"}
                      </button>
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* Payment CTA Card */}
          <div className="bg-white rounded-2xl shadow-sm flex flex-col gap-6 px-6 pt-4 pb-6 w-full">
            {/* Agreement checkbox */}
            <div className="flex items-start gap-2.5 w-full">
              <div
                role="checkbox"
                aria-checked={agreement}
                tabIndex={0}
                onClick={() => setAgreement(!agreement)}
                onKeyDown={(e) => e.key === " " && setAgreement(!agreement)}
                className={`rounded shrink-0 flex items-center justify-center cursor-pointer mt-0.5 border-2 transition-colors ${agreement ? "bg-[#2563eb] border-[#2563eb]" : "bg-white border-[#d1d5db]"}`}
                style={{ width: 18, height: 18, minWidth: 18 }}
              >
                {agreement && <img src="/assets/checkout/check.svg" alt="" style={{ width: 10, height: 10 }} />}
              </div>
              <div className="flex flex-col gap-1 items-start">
                <p className="text-[#1f2937] text-sm font-semibold text-left">I hereby agree to terms and conditions with the company.</p>
                <span onClick={() => setTandcOpen(true)} className="text-[#2563eb] text-xs underline cursor-pointer text-left">View Agreement Policy Document</span>
              </div>
            </div>

            <hr className="border-[#e5e7eb] w-full" />

            <div className="flex flex-col gap-4 w-full">
              <div className="flex items-center justify-between w-full">
                <p className="text-[#6b7280] text-sm font-semibold uppercase tracking-wide text-left">Total Rental Payable</p>
                {carData && (
                  <button onClick={showModal} className="bg-white border border-[#072a79] px-2 py-1 rounded-md inline-flex items-center w-[128px] justify-center">
                    <span className="text-[#0a3085] text-[14px] font-medium leading-none p-1">Fare Summary</span>
                  </button>
                )}
              </div>
              <div className="flex items-baseline gap-2">
                <p className="text-[#cd2525] text-4xl font-extrabold">₹{payableAmount}</p>
                <p className="text-[#6b7280] text-xs">+ Inc tax &amp; security deposit</p>
              </div>
            </div>

            {carData && (
              <button
                onClick={handleProceed}
                className="w-full h-16 flex items-center justify-center rounded-xl text-white text-base font-semibold shadow-[0px_8px_10px_rgba(37,99,235,0.25)]"
                style={{ background: "linear-gradient(45deg, #9E85DD 25%, #7B39EC 59.86%)" }}
              >
                Proceed &amp; Pay
              </button>
            )}
          </div>
        </div>
      </div>

      {isEvBooking && <TermsCard onViewAll={() => setTandcOpen(true)} />}

      {/* ── CRITICAL NOTICE CARD ── */}
      <div className="w-full mt-8 mb-32">
        <div className="bg-white border border-[#e5e7eb] rounded-2xl shadow-sm p-8 flex flex-col gap-6">
          {/* Header */}
          <div className="flex items-stretch gap-4">
            <div className="bg-[#ed1c24] w-2 rounded-[4px] shrink-0" />
            <div className="flex flex-col justify-center gap-2">
              <span className="block text-[#ed1c24] text-[14px] font-extrabold uppercase tracking-[1.2px] leading-5 text-left">IMPORTANT</span>
              <span className="block text-[#1f2937] text-[28px] font-extrabold leading-9 text-left">Important Rent Information &amp; Guidelines</span>
            </div>
          </div>

          <hr className="border-[#e5e7eb]" />

          {/* Points */}
          <p className="text-[#1f2937] text-[15px] font-semibold leading-[3] text-left">
            <span className="text-[#ed1c24] font-extrabold">Fuel, Tolls, Parking, and Inter-State Taxes:</span> These charges are to be borne by the customer.<br />
            <span className="text-[#ed1c24] font-extrabold">Change in Pricing Plan (Without Fuel):</span> The pricing plan cannot be changed once the booking is confirmed.<br />
            <span className="text-[#ed1c24] font-extrabold">Required Documents for KYC Verification:</span> Driving License, Aadhar Card, and one of the following: Employee ID card / Student ID card / GST Certificate (for business holders).<br />
            <span className="text-[#ed1c24] font-extrabold">For local residents of the vehicle pickup city:</span> A valid address proof such as a Rental Agreement, Gas Bill, Utility Bill, Communication Bill, or PG Accommodation Bill. For non-local residents: Travel tickets and hotel reservation.<br />
            <span className="text-[#ed1c24] font-extrabold">Age Criteria:</span> The minimum permissible age for renting a Wowcarz car is 21 years.<br />
            <span className="text-[#ed1c24] font-extrabold">ID Verification:</span> The driving license must be at least one year old as of the rental start date. At the time of car pickup, the booking person must have the original driving license or its DigiLocker version handy. Our executive will physically verify the license and require one original document to be submitted. This verification process is mandatory. If you are unable to provide these documents, we will not be able to hand over the car, and the booking will be treated as a late cancellation, incurring a charge of 100% of the fare.
          </p>

          {/* Footer note */}
          <div className="flex items-center gap-3">
            <div className="bg-[#ed1c24] rounded-xl w-6 h-6 flex items-center justify-center shrink-0">
              <img src="/assets/checkout/check.svg" alt="" className="w-3.5 h-3.5" style={{ filter: "brightness(0) invert(1)" }} />
            </div>
            <p className="text-[#6b7280] text-[13px] font-medium flex-1 text-left">
              Please ensure you have read and understood all the above points before proceeding to payment.
            </p>
          </div>
        </div>
      </div>
      </>
      )}
    </>
  );
};

export default Checkout;
